/** The rules of a demo plan that the demo data and the onboarding steps read, kept apart from the plan itself so the data never imports the plan at run time (the plan imports the data). */
import type { DemoPlan } from './demoPlan.js'

/** How many of a facility's active workers go into the pools it is asked to rank. */
export const RANKING_POOL_SIZE = 4
/** True for a plan with no demo data to set up - the client alone. */
export function isBlankPlan(plan: Pick<DemoPlan, 'size'>): boolean {
  return plan.size === 'blank'
}
export function monthsToClose(plan: DemoPlan): number {
  if (isBlankPlan(plan)) {
    return 0
  }
  return Math.max(plan.monthSpan - 1, plan.includesTrainingCast ? 1 : 0)
}
